module.exports = __webpack_public_path__ + "img/software_clio.de5f357c.jpg";